/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotelBookingsService } from '@app/hotels/hotel-bookings/hotel-bookings.service';
import { ApiQuery } from '@app/core/http/api-query';

@Component({
  selector: 'app-hotel-bookings-preview-rooms',
  templateUrl: './hotel-bookings-preview-rooms.component.html',
  styleUrls: ['./hotel-bookings-preview-rooms.component.scss'],
})
export class HotelBookingsPreviewRoomsComponent implements OnInit {
  @Input() hotelBookingId = 0;
  rooms: any[] = [];
  columns: string[] = [];
  loading = false;

  constructor(
    public modal: NgbActiveModal,
    private hotelBookingService: HotelBookingsService
  ) {}

  ngOnInit() {
    if (!this.hotelBookingId) {
      return;
    }

    this.loading = true;
    const query = new ApiQuery().addIncludes(
      'booking',
      'booking.company',
      'booking.events',
      'hotel',
      'meal_plan',
      'nights',
      'nights.sale',
      'nights.sale.company',
      'nights.sale.client',
      'nights.sale_final_item.sale_offer_item.meal_plan',
      'nights.sale_final_item.sale_offer_item.type'
    );
    this.hotelBookingService.previewSoldRooms(this.hotelBookingId, query).subscribe(
      (rooms: any[]) => {
        this.rooms = rooms || [];
        this.columns = this.rooms.length ? Object.keys(this.rooms[0]) : [];
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  formatCell(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    return typeof value === 'object' ? JSON.stringify(value) : String(value);
  }
}
